module.exports = __webpack_public_path__ + "img/marido-log-bg.e017ecf0.jpg";